module.exports = __webpack_public_path__ + "media/images/legacy/transparent-white-4aecce664e4f45f3fbe1a0be811099fe.png";